import React, { useState } from "react";

const productsData = [
  {
    name: "Round Plastic Table",
    image: "/img/roundtable1.jpeg", // Correct path
    description: "Perfect for various events and gatherings.",
    price: "$10.00/$12.00",
    details: "Available in multiple sizes and styles. Suitable for indoor and outdoor use."
  },
  {
    name: "Rectangular Plastic Table",
    image: "/img/rectangletable.jpeg", // Correct path
    description: "Perfect for various events and gatherings.",
    price: "$10.00/$12.00",
    details: "Available in multiple sizes and styles. Suitable for indoor and outdoor use."
  },
  {
    name: "Cocktail Table",
    image: "/img/cocktail.png",
    description: "Elegant solution for cocktail parties.",
    price: "$18.00",
    details: "Height-adjustable cocktail tables, perfect for drinks and mingling."
  },
  {
    name: "Chair",
    image: "/img/chair1.jpeg",
    description: "Comfortable seating for guests.",
    price: "$2.00",
    details: "Durable and stackable chairs available in various colors."
  },
  {
    name: "Buffet Servers",
    image: "/img/buffet1.jpeg",
    description: "Ideal for serving food at events.",
    price: "$20.00",
    details: "Keep food warm and organized with our high-quality buffet servers."
  },
  {
    name: "Bouncing House",
    image: "/img/bounce.jpeg",
    description: "Fun addition for children's parties.",
    price: "$125.00 - $250.00",
    details: "Available in various sizes and themes for endless fun."
  },
  {
    name: "Night Light",
    image: "/img/nightlight.jpeg",
    description: "Enhance visibility during evening events.",
    price: "$25.00 each",
    details: "Portable night lights with adjustable brightness settings."
  },
  {
    name: "Canopy 10x10",
    image: "/img/canopy.jpeg",
    description: "Perfect for outdoor events, providing shade and shelter.",
    price: "$60/day",
    details: "Durable and easy-to-assemble canopies with optional sidewalls."
  }
];



export const Products = () => {
  const [selectedProduct, setSelectedProduct] = useState(null);

  const handleProductClick = (product) => {
    setSelectedProduct(product);
  };

  const closeModal = () => {
    setSelectedProduct(null);
  };

  return (
    <div id="products" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Our Products</h2>
          <p>
            Perfect for Thanksgiving, Birthdays, Weddings, Baby Showers, Corporate Events, Pop-Up Shops, and Christmas. Let us provide you with stylish and functional solutions for all your events.
          </p>
        </div>
        <div className="row">
          {productsData.map((product, index) => (
            <div key={index} className="col-md-4">
              <div
                className="product-item"
                onClick={() => handleProductClick(product)}
              >
                <img
                  src={product.image}
                  alt={product.name}
                  className="img-fluid"
                />
                <h3>{product.name}</h3>
                <span className="price">{product.price}</span>
              </div>
            </div>
          ))}
        </div>

        {selectedProduct && (
          <div className="product-modal">
            <div className="modal-content">
              <span className="close" onClick={closeModal}>
                &times;
              </span>
              <h3>{selectedProduct.name}</h3>
              <img
                src={selectedProduct.image}
                alt={selectedProduct.name}
                className="img-fluid"
              />
              <p>{selectedProduct.details}</p>
              <span className="price">{selectedProduct.price}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
